import api from "../../../utilities/Interceptor";

const url = process.env.REACT_APP_API_KEY

export const getPol = (setDocument: any, name: string | undefined) => {
    api.get<{ POLITICA_SERVICIO: string }>(`${url}/maps/documents?name=${name}`)
        .then((res) => {
            const doc = `https://repo.sumaenlinea.mx/documentos/${res.data.POLITICA_SERVICIO ? res.data.POLITICA_SERVICIO : "POLITICA_SERVICIO.html"}`
            setDocument(doc);
        }
    ).catch((error) => {
        console.log("error", error);
    })
}